import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Benefits from "../components/Benefits";
import Ecommerce from "../components/Ecommerce";
import Integrations from "../components/Integrations";
import HowWeWork from "../components/HowWeWork";
import Footer from "../components/Footer";

const Homepage = () => {
  useEffect(() => {
    // Manejar hash en la URL al cargar la página
    const handleHashScroll = () => {
      const hash = window.location.hash.substring(1); // Remover el #
      if (hash) {
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100); // Pequeño delay para asegurar que el DOM esté listo
      }
    };

    handleHashScroll();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Benefits />
      <Ecommerce />
      <Integrations />
      <HowWeWork />
      <Footer />
    </div>
  );
};

export default Homepage;